// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
export enum MountedOnType {
	TmaTruck = 1,
	TrailerAttenuator = 2,
	ShadowVehicle = 3,
	ArrowBoardTrailer = 4,
	VmsSignTrailer = 5,
	Other = 99,
}

export const MountedOnTypeDisplayNames: { [key in keyof typeof MountedOnType]?: string} = {
	"TmaTruck": "TMA truck",
	1 : "TMA truck",
	"TrailerAttenuator": "Trailer-mounted attenuator",
	2 : "Trailer-mounted attenuator",
	"ShadowVehicle": "Shadow vehicle",
	3 : "Shadow vehicle",
	"ArrowBoardTrailer": "Arrow board trailer",
	4 : "Arrow board trailer",
	"VmsSignTrailer": "VMS sign trailer",
	5 : "VMS sign trailer",
	"Other": "Other",
	99 : "Other",
}

export const getMountedOnTypeDisplayName = (key: MountedOnType | (keyof typeof MountedOnType & string)) => {
	return MountedOnTypeDisplayNames[key];
}

